export default __webpack_public_path__ + "static/media/hack.44cbb8df.gif";